import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import { normalizeRole } from '../lib/roles';

export function useCurrentUser(session) {
    const [currentUser, setCurrentUser] = useState(null);
    const [role, setRole] = useState(null);
    const [loadingUser, setLoadingUser] = useState(true);

    useEffect(() => {
        if (!session?.user?.email) {
            // Sincroniza com a saída da sessão (logout / sessão ausente). Derivar isso no
            // render não serve: o valor precisa mudar quando a prop muda, e o caminho normal
            // é assíncrono. Um render extra aqui não tem custo observável.
            // eslint-disable-next-line react-hooks/set-state-in-effect
            setLoadingUser(false);
            return;
        }
        const email = session.user.email;
        supabase
            .from('bd_pessoas')
            .select('nome, cargo, email, atividade')
            .eq('email', email)
            .neq('atividade', 'inativo')
            .limit(1)
            .then(({ data }) => {
                const user = data?.[0] ?? null;
                setCurrentUser(user);
                setRole(normalizeRole(user?.cargo, email));
            })
            .catch(() => {
                setCurrentUser(null);
                // orbioncontato@gmail.com fallback even on error
                setRole(normalizeRole(null, email));
            })
            .finally(() => setLoadingUser(false));
    }, [session?.user?.email]);

    return { currentUser, role, loadingUser };
}
